module.exports = __webpack_public_path__ + "static/loader-213d08181ad3b0990d33b6bbbdc58e0f.gif";